"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types");
var _logger = require("@studio/logger");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var initialState = [];
/**
 * updates the status of file
 * and add the file only if it is in uploading state
 */
function uploadStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var loggerName = 'studio-uploadStatusUpdate-tracker';
  // this is dispatched while performing the actual upload
  if (action.type === _types.BROADCAST_SET_SOURCE_UPLOAD_STATUS) {
    var index = state.findIndex(function (source) {
      return source.sourceId === action.payload.sourceId;
    });
    if (index !== -1) {
      (0, _logger.sendToDatadog)(loggerName, action.payload, "Status of source file ".concat(action.payload.sourceId, " got updated to ").concat(action.payload.status), false);
      return state.map(function (source) {
        if (source.sourceId === action.payload.sourceId) {
          source.status = action.payload.status;
        }
        return source;
      });
    } else {
      if (action.payload.status === 'UPLOADING') {
        (0, _logger.sendToDatadog)(loggerName, action.payload, "Source file ".concat(action.payload.sourceId, " got added"), false);
        return [action.payload].concat(_toConsumableArray(state));
      }
    }
  }

  // Clears the state and logs the action with Datadog when the 'UploadStatusPane' modal is closed.
  // Checks if action type is SET_UPLOAD_STATUS_VISIBILITY with a false payload.
  if (action.type === _types.SET_UPLOAD_STATUS_VISIBILITY && action.payload === false) {
    if (state.length > 0) {
      (0, _logger.sendToDatadog)(loggerName, action.payload, "State uploadStatus got cleared", false);
    }
    return initialState;
  }
  return state;
}
var _default = exports["default"] = uploadStatus;